import React from 'react';
import { Palette } from 'lucide-react'; // Icône pour la signature

function SignatureInputForm({ signature, onSignatureChange }) {
  return (
    <div className="my-6 p-4 bg-slate-50 border border-slate-200 rounded-lg shadow-sm">
      <label htmlFor="signatureTextarea" className="block text-sm font-medium text-gray-700 mb-1">
        <Palette size={16} className="inline-block mr-2 text-gray-500" />
        Code HTML de la signature à appliquer
      </label>
      <textarea
        id="signatureTextarea"
        name="signature"
        value={signature}
        onChange={(e) => onSignatureChange(e.target.value)}
        placeholder="Collez le code HTML de la signature ici. Cette signature sera appliquée aux utilisateurs sélectionnés."
        rows={8} // Un peu moins haut par défaut
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      />
      <p className="mt-2 text-xs text-gray-500">
        Assurez-vous que le code HTML est valide et complet.
      </p>
    </div>
  );
}

export default SignatureInputForm; 